import { AxiosService } from 'network/config/config'
import { Endpoints } from 'network/config/endpoints'
import { IPayload } from 'models/Global'
import {
  IInterviewBotResponse,
  IPostInterviewBotResponseParams,
} from 'models/InterviewBot'

export class InterviewBotApi {
  constructor(private axios: AxiosService) {}

  postInterviewBotResponse = async (
    params: IPostInterviewBotResponseParams,
  ) => {
    const response = await this.axios.post<IPayload<IInterviewBotResponse>>(
      Endpoints.postInterviewBotResponse,
      params,
    )
    return response
  }
}
